import { Fail, Success } from 'monet';

/**
 * @description Запрос на регистрацию.
 * @param {string} clinicCity  Город клиники.
 * @param {string} clinicName  Название клиники.
 * @param {string} userEmail   Адрес электронной почты пользователя.
 * @param {string} userName    Имя пользователя.
 * @param {string} userPhone   Номер сотового телефона пользователя.
 * @param {string} userSurname Фамилия пользователя.
 * @constructor
 */
export function RegistrationRequest(
  clinicCity,
  clinicName,
  userEmail,
  userName,
  userPhone,
  userSurname,
) {
  /**
   * @description Преобразовать в формат запроса.
   * @returns {any}
   */
  this.toQuery = () => ({
    clinic_city: clinicCity,
    clinic_name: clinicName,
    user_email: userEmail,
    user_name: userName,
    user_phone: userPhone,
    user_surname: userSurname,
  });
}

/**
 * @description Шлюз регистрации клиники.
 * @param {Axios} axios HTTP клиент.
 * @constructor
 */
export default function RegisterClinicGateway(axios) {
  /**
   * @description Отправить запрос на регистрацию.
   * @param {any} params Параметры запроса.
   * @returns {function(request: RegistrationRequest): Promise}
   */
  this.send = (params) => (request) => axios
    .post('/api/clinics', request.toQuery(), { params })
    .then(
      async (response) => {
        const clinicId = response.data.clinic_id;
        const message = 'Успешно отправлено';
        return Success({ clinicId, message });
      },
      async (error) => {
        if (error.isAxiosError && error.response.status === 400) {
          const { causes, message } = error.response.data;
          return Fail({ causes, message });
        }
        throw error; // oh no
      },
    );
}
